import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { Modal } from 'bootstrap';
import TapSelect from '../../components/ui/TapSelect';
import { useSelector } from 'react-redux';
import HttpAPICall from '../../services/HttpAPICall';
import { BACKOFFICE_BASE_URL } from '../../services/TapApiUrls';
import Loader from '../../components/ui/Loader/Loader';
import DatePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";

const UpdateLicenseModal = forwardRef(({ onSearch, initialSearchForm ,groupDetail }, ref) => {
    const modelFormDataUrl               =       BACKOFFICE_BASE_URL + '/model/form_data'
    const modalElem = useRef(null);
    const modal = useRef(null);
    const [form_loading, setForm_loading] = useState(false);
    const access_token = useSelector(state => state.auth.access_token);

    const initSearchForm         =          {
        search_name                         :   '',
        search_manufacturers                :   [],
    };

    const searchFormLabel        =          {
        search_name                         :   'Name : ',
        search_manufacturers                :   'Manufacturers : ',
    };

    const [manufacturers, setManufacturers] = useState([]);
    const [modelSearchForm, setModelSearchForm] = useState({ ...initSearchForm, ...initialSearchForm });
    const resetForm = () => {
        setModelSearchForm({ ...initSearchForm });
    };

    useImperativeHandle(ref, () => ({
        initModalHandler: () => {
            modalOpen();
        },
        resetForm: resetForm
    }));

  
    const modalOpen = () => {
        if (modal.current) { modal.current.show(); }
    };

    const modalClose             =       ()     => {
        if (modal.current) { modal.current.hide(); }
    };
    const getSearchFormData     =        ()     =>  {
        setForm_loading(true);
        HttpAPICall.withAthorization('GET', modelFormDataUrl, access_token, {}, {}, (resp) => {
            let respData = resp.data.manufacturers;
            setManufacturers(respData.map(m => ({ value: m.id, label: m.manufacturer })));
        }).then(() => setForm_loading(false));
    };


    useEffect(() => {
        getSearchFormData()
        modalElem.current = document.getElementById('searchModal');
        modal.current = new Modal(modalElem.current, { keyboard: false, backdrop: false });
        return () => {
            if (modal.current) {
                modal.current.dispose();
            }
        };
    }, []);


    const tapSelectChange = (selectedOption, form, formKey) => {
        if (form && formKey) {
            const newStateData = Array.isArray(selectedOption)
                ? { ...modelSearchForm, [formKey]: selectedOption.length > 0 ? selectedOption.map(o => o.value) : [] }
                : { ...modelSearchForm, [formKey]: selectedOption ? selectedOption.value : '' };

            setModelSearchForm(newStateData);
        }
    };

    const submitSearchForm = (e) => {
        e && e.preventDefault();
        let serachFormKeys = Object.keys(modelSearchForm);
        let searchedElems = [];
        let searchParams = {};
        serachFormKeys.map((key) => {
            let label = searchFormLabel[key];
            let value = modelSearchForm[key];

            if (value && value.toString().length > 0) {
                searchParams[key] = value;
                if (label) {
                    let show_val = value;
                    if (key === 'search_manufacturers') {
                        show_val = manufacturers.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    searchedElems.push(label + `<b>${show_val}</b>`);
                }
            }
        });
        onSearch(searchParams, searchedElems);
        modalClose();
    };

    const searchModalJsx = () => {
        return (
            <div className="modal fade" id="searchModal" tabIndex="-1" ref={modalElem}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="searchAssetModalLabel">Update Details</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <form id="modelSearchForm" onSubmit={submitSearchForm}>
                            <div className="modal-body">
                                {form_loading
                                    ?
                                    <Loader />
                                    :
                                    <>
                                    <div className="row align-items-center my-3">
                                        <label className="col-sm-3 col-form-label col-form-label-sm">Group Name</label>
                                        <div className="col-sm-9">
                                            <input
                                                name="group_name"
                                                type="text"
                                                className="form-control form-control-sm"
                                                autoComplete="off"
                                                placeholder="Enter Group Name"
                                                // onChange={(e) => { this.formInputHandler(e, 'addIamSubmoduleForm') }}
                                                disabled
                                                value={groupDetail?.group_name || "-"}
                                            />
                                        </div>
                                    </div>
                                      <div className="row align-items-center my-3">
                                        <label className="col-sm-3 col-form-label col-form-label-sm">Sub Module</label>
                                        <div className="col-sm-9">
                                            <TapSelect
                                                // changeEvent={(selectedOption) => {
                                                //     tapSelectChange(selectedOption, 'addIamSubmoduleForm', 'sub_module_id', () => {
                                                //         let group_list = this.state.allGroupLicencedModuleList;
                                                //         let group_licensed_detail = group_list && group_list.length > 0 ? group_list.find(gm => gm.value == selectedOption.value) : null;
                                                //         this.setState({
                                                //             addIamSubmoduleForm: {
                                                //                 ...this.state.addIamSubmoduleForm,
                                                //                 till: group_licensed_detail && group_licensed_detail.till ? group_licensed_detail.till : ''
                                                //             }
                                                //         })
                                                //     });
                                                // }}
                                                // options={this.state.allSubModuleList}
                                                isSearchable={true}
                                                isClearable={true}
                                                required={true}
                                                // value={this.state.allSubModuleList.find(s => s.value == this.state.addIamSubmoduleForm.sub_module_id)}
                                                placeholder="Select Sub Module"
                                                containerHeight="30px"
                                                fontSize="93%"
                                            />
                                        </div>
                                    </div>
                                  
                                   
                                       
                                      <div className="row align-items-center my-3">
                                        <label className="col-sm-3 col-form-label col-form-label-sm">Current Expiry Date</label>
                                        <div className="col-sm-9">
                                            <DatePicker
                                                // selected={
                                                //     this.state.addIamSubmoduleForm.till
                                                //         ? moment(this.state.addIamSubmoduleForm.till, 'YYYY-MM-DD').toDate()
                                                //         : false
                                                // }
                                                name="till"
                                                // onChange={(value, event) => this.formDateHandler('till', value, 'addIamSubmoduleForm')}
                                                maxDate={moment(new Date(), 'YYYY-MM-DD').toDate()}
                                                dateFormat="dd-MMM-yyyy"
                                                className={"form-control form-control-sm"}
                                                showMonthDropdown
                                                showYearDropdown
                                                autoComplete="off"
                                                scrollMonthYearDropdown
                                                required={true}
                                                containerHeight="30px"
                                                fontSize="93%"
                                                disabled
                                                placeholderText={`Please Enter Current Expiry Date`}
                                            />
                                        </div>
                                         <div className="row align-items-center my-3">
                                        <label className="col-sm-3 col-form-label col-form-label-sm">New Expiry Date</label>
                                        <div className="col-sm-9">
                                            <DatePicker
                                                // selected={
                                                //     this.state.addIamSubmoduleForm.new_till
                                                //         ? moment(this.state.addIamSubmoduleForm.new_till, 'YYYY-MM-DD').toDate()
                                                //         : false
                                                // }
                                                name="new_till"
                                                // onChange={(value, event) => this.formDateHandler('new_till', value, 'addIamSubmoduleForm')}
                                                minDate={moment(new Date(), 'YYYY-MM-DD').toDate()}
                                                dateFormat="dd-MMM-yyyy"
                                                className={"form-control form-control-sm"}
                                                showMonthDropdown
                                                showYearDropdown
                                                autoComplete="off"
                                                scrollMonthYearDropdown
                                                required={true}
                                                containerHeight="30px"
                                                fontSize="93%"
                                                placeholderText={`Please Enter New Expiry Date`}
                                            />
                                        </div>
                                    </div>
                                    </div>
                                    </>}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button type="submit" className="btn btn-primary">Search</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            {searchModalJsx()}
        </>
    );
});

export default UpdateLicenseModal;
